// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invisible-recaptcha[data-v-0789212e]{height:0;width:0;overflow:hidden}", ""]);
// Exports
module.exports = exports;
